'use strict';

import {recoveryModel} from "@js/models/recoverymodel";

export class ProjectRecoveryListCtrl
{
	recoveries = [];
	
	constructor($scope, $filter, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.setRecoveries(this.jsDataService.get('recoveries', {}));
	}
	
	setRecoveries(recoveries){
		this.recoveries = [];
		for(let recoveryData of recoveries){
			this.recoveries.push(new recoveryModel(recoveryData, this.$filter, this.jsDataService));
		}
	}
	
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
}


